import { useAqua, setAqua } from '../lib/aquaStore';
import { PCOL, TCOL } from '../lib/aquaNet';
import { KCOL } from '../hooks/useAquaLayer';

const LEG = {
  p: { list: PCOL, unit: 'bar' },
  t: { list: TCOL, unit: '°C' },
  age: { list: [[6, '#16a34a'], [24, '#eab308'], [72, '#f97316'], [Infinity, '#dc2626']], unit: 'h' },
  k: { list: KCOL, unit: 'mm' },
  v: { list: [[0.1, '#7c3aed'], [0.5, '#2563eb'], [1.5, '#16a34a'], [2.5, '#f97316'], [Infinity, '#dc2626']], unit: 'm/s' },
};

// colour mode switch + scale for the AquaFlow map colouring
export function AquaLegend({ t }) {
  const s = useAqua(), modes = [...(s.res && !s.res.error ? ['p', 'v', 'k'] : []), ...(s.th ? ['t'] : []), ...(s.th || s.eps ? ['age'] : [])], L = LEG[s.mode] || LEG.p;
  return (
    <div className="aq-legend" data-testid="aq-legend">
      <div className="aq-tabs aq-colors">
        <small className="aq-colors-lbl">{t.aqColorBy}</small>
        {modes.map((m) => <button key={m} className={`chip ${s.mode === m ? 'on' : ''}`} data-testid={`aq-color-${m}`} onClick={() => setAqua({ mode: m })}>{t['aqCol_' + m]}</button>)}
        <button className={`chip aq-layer-btn ${s.on ? '' : 'off'}`} data-testid="aq-layer-toggle" onClick={() => setAqua({ on: !s.on })}>{s.on ? t.aqHide : t.aqShow}</button>
      </div>
      {s.mode === 'k' && <small className="muted" data-testid="aq-kmap-hint">{t.aqKMapHint}</small>}
      <div className="aq-scale">
        {L.list.map(([x, c], i) => <span key={c + i}><i style={{ background: c }} />{!i ? `< ${x}` : Number.isFinite(x) ? `${L.list[i - 1][0]}–${x}` : `> ${L.list[i - 1][0]}`} {L.unit}</span>)}
      </div>
    </div>
  );
}
